export default "__VITE_ASSET__DjZW2Ryk__"